import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newProject(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PROJECT_START", payload: "" })
            
            console.log("new Project START", {data})
            const res = await axios.post('/projects/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_PROJECT_ERROR", dispatch ) ) {
                res.data.project_name = capitalizeWord(res.data.project_name)
				dispatch({ type: "NEW_PROJECT", payload: res.data })
				dispatch({ type: "CREATE_PROJECT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new project ", err);
            dispatch({
                type: "CREATE_PROJECT_ERROR",
                payload: err
            })
        }
    }
}

export function fetchProjects() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PROJECTS_START", payload: "" })

            console.log("fetch Project START")
            const res = await axios.get('/projects/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_PROJECTS_ERROR", dispatch ) ) {               
                let list = capitalize(orderByAsc(res.data, "project_name"), "project_name")
                dispatch({
                    type: "GET_PROJECTS",
                    payload: formatList(list, "project_id")
                })
                dispatch({ type: "FETCH_PROJECTS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get projects list ", err);
            dispatch({ type: "FETCH_PROJECTS_ERROR", payload: err })
        }
    }
}

export function updateProject(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_PROJECT_START", payload: "" })

            console.log("update Project START")
            const res = await axios.post("/projects/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_PROJECT_ERROR", dispatch ) ) {               
                data.project_name = capitalizeWord(data.project_name)
				dispatch({
                    type: "UPDATE_PROJECT",
                    payload: data
                })
				dispatch({ type: "UPDATE_PROJECT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update project ", err);
            dispatch({
                type: "UPDATE_PROJECT_ERROR",
                payload: err
                
            })
        }
    }
}
export function addSpendingToProject(list, project_id) { // {list, project_id}
    return async function(dispatch){
        try{
            dispatch({ type: "ADD_SPENDING_TO_PROJECT_START", payload: "" })

            console.log("update Project START")
            const res = await axios.post("/projects/spending/add", {data: {list, project_id} })
            console.log({res});
            
            if (checkErrorData(res, "ADD_SPENDING_TO_PROJECT_ERROR", dispatch ) ) {               
				dispatch({
                    type: "ADD_SPENDING_TO_PROJECT",
                    payload: {list, project_id}
                })
				dispatch({ type: "ADD_SPENDING_TO_PROJECT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update project ", err);
            dispatch({
                type: "ADD_SPENDING_TO_PROJECT_ERROR",
                payload: err
                
            })
        }
    }
}
